const SOURCE_DESCRIPTOR_LIST = [
  { sourceKey: 'search', loading: 'eager' },
  { sourceKey: 'people', loading: 'eager' },
  { sourceKey: 'docs', loading: 'deferred' },
  { sourceKey: 'navigation', loading: 'eager' },
  { sourceKey: 'integrations', loading: 'deferred' },
  { sourceKey: 'adAudiences', loading: 'deferred' },
  { sourceKey: 'forms', loading: 'deferred' },
  { sourceKey: 'webhooks', loading: 'deferred' },
  { sourceKey: 'cdpOut', loading: 'deferred' },
  { sourceKey: 'dataOut', loading: 'deferred' },
  { sourceKey: 'objectTypes', loading: 'deferred' },
] as const;

type SourceDescriptorList = typeof SOURCE_DESCRIPTOR_LIST;

export type SourceDescriptor = SourceDescriptorList[number];
export type SourceKey = SourceDescriptor['sourceKey'];
export type DeferredSourceKey = Extract<SourceDescriptor, { loading: 'deferred' }>['sourceKey'];

export const SOURCE_DESCRIPTORS = SOURCE_DESCRIPTOR_LIST satisfies ReadonlyArray<{
  sourceKey: string;
  loading: 'eager' | 'deferred';
}>;

export const SOURCE_KEYS = SOURCE_DESCRIPTORS.map((descriptor) => descriptor.sourceKey);

function isDeferredSourceDescriptor(
  descriptor: SourceDescriptor,
): descriptor is Extract<SourceDescriptor, { loading: 'deferred' }> {
  return descriptor.loading === 'deferred';
}

export const DEFERRED_SOURCE_KEYS_LIST = SOURCE_DESCRIPTORS.filter(isDeferredSourceDescriptor).map(
  (descriptor) => descriptor.sourceKey,
);
